import { Trans } from "react-i18next";

export const StrongTranslationString = ({
  i18nKey,
  param,
  color = "var(--color-secondary)",
  underline = false,
  count = 0,
  onClick,
}: {
  i18nKey: string;
  param?: Record<string, string | number>;
  color?: string;
  underline?: boolean;
  count?: number;
  onClick?: () => void;
}) => {
  return (
    <Trans
      i18nKey={i18nKey}
      values={param}
      count={count}
      components={{
        strong: (
          <strong
            style={{
              color,
              textDecoration: underline ? "underline" : "none",
              cursor: onClick ? "pointer" : "inherit",
            }}
            onClick={onClick}
          />
        ),
      }}
    />
  );
};

export const TranslationString = ({
  i18nKey,
  param,
  count = 0,
  color = "var(--color-secondary)",
  underline = false,
  onClick,
}: {
  i18nKey: string;
  param?: Record<string, string | number>;
  count?: number;
  color?: string;
  underline?: boolean;
  onClick?: () => void;
}) => {
  return (
    <Trans
      i18nKey={i18nKey}
      values={param}
      count={count}
      components={{
        span: (
          <span
            style={{
              color,
              textDecoration: underline ? "underline" : "none",
              cursor: onClick ? "pointer" : "inherit",
            }}
            onClick={onClick}
          />
        ),
      }}
    />
  );
};
